var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"persistent":"","max-width":"510"},model:{value:(_vm.openDialog),callback:function ($$v) {_vm.openDialog=$$v},expression:"openDialog"}},[_c('SmsAddContactToGroupForm',{attrs:{"group":_vm.group},on:{"selectionCompleted":_vm.handleSelection,"close":_vm.close}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }